import React, { Suspense } from 'react';

/**
 * 路由级代码分割 fallback：轻量占位，避免全屏「正在验证登录状态」与页面加载叠加。
 */
export default function RoutePageSuspense({ children, label = '正在加载页面…' }) {
  return (
    <Suspense
      fallback={(
        <div className="ipe-route-loading" role="status" aria-live="polite">
          <div className="ipe-route-loading__bar" aria-hidden="true" />
          <p>{label}</p>
        </div>
      )}
    >
      {children}
    </Suspense>
  );
}
